import { Controller } from 'react-hook-form';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { FormInput } from 'ui/components/elements/FormInput/FormInput';
import { FormLabel } from 'ui/components/elements/FormLabel/FormLabel';
import { useModal } from 'ui/components/screens/modals/useModal';
import { useForgotPassword } from './useForgotPassword';

const Opener = styled.button`
    width: 100%;
    margin-block: 0;
    font-size: var(--font-medium);
    color: #ff4500;
    cursor: pointer;
    text-align: right;
    background: #fff;
    border: 1px solid #ff4500;
    border-radius: 10px;
    padding: 10px;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 24px 40px;
`;

const Title = styled.h3`
    width: 100%;
    margin-block: 0;
    margin-bottom: 30px;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
`;
const Desc = styled.p`
    margin-block: 0 30px;
    text-align: ${(props: { align: string }) => props.align};
`;

const Group = styled.div`
    position: relative;
    width: 100%;
    align-items: center;
    margin-bottom: 50px;
    text-align: center;
    input {
        width: 100%;
        ${mqMin('NARROW')} {
            width: 380px;
        }
    }
`;
const LabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: fit-content;
    margin-inline: auto;
    text-align: left;

    // 小要素のdivを強制的に左寄せ
    div {
        margin-right: auto;
    }
`;

const Button = styled.button`
    width: 100%;
    max-width: 380px;
    padding: 16px;
    border-radius: 60px;
    background-color: #ed793e;
    color: var(--white);
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
`;

/**
 * パスワードを忘れた方へ フォーム
 */
export const ForgotPassword: React.FC = () => {
    const { openModal, createModal } = useModal();
    const {
        control,
        formState: { errors },
        requesting,
        completed,
        submit,
    } = useForgotPassword();

    return (
        <>
            <Opener onClick={openModal}>パスワードを忘れた方はこちら</Opener>
            {createModal(
                <Wrapper>
                    <Title>パスワードを忘れた方へ</Title>
                    {completed ? (
                        <Desc align="left">
                            再設定用メールをお送りしました。
                            <br />
                            メールに書かれているURLよりパスワードを再設定してください。
                            <br />
                            メールが届かない場合はメールアドレスが正しいかご確認ください。
                        </Desc>
                    ) : (
                        <>
                            <Desc align="center">
                                ご登録のメールアドレスを入力ください。
                                <br />
                                入力いただいたメールアドレスにパスワードリセットURLを送付いたします。
                            </Desc>
                            <Group>
                                <LabelContainer>
                                    <FormLabel title="メールアドレス" isRequired />
                                    <Controller
                                        name="email"
                                        control={control}
                                        render={({ field }) => (
                                            <FormInput
                                                {...field}
                                                placeholder="email"
                                                hasError={!!errors.email?.message}
                                            />
                                        )}
                                    />
                                </LabelContainer>
                            </Group>
                            <Button disabled={requesting} onClick={submit}>
                                メールを送信する
                            </Button>
                        </>
                    )}
                </Wrapper>,
            )}
        </>
    );
};
